export default {
    path : "factory-item-sea",
    name : "factory-item-sea",
    meta : {
        title : "项目公海"
    },
    component: () => import('@/pages/factory/sea/Index'),
    redirect: {
        name : "factory-item-sea-whole"
    },
    children: [
        {
            path: 'all',
            name: 'factory-item-sea-whole',
            meta: {
                title: '厂房项目-列表页'
            },
            component: () => import('@/pages/itemCommon/List'),
        },
        {
            path: 'recent',
            name: 'factory-item-sea-recent',
            meta: {
                title: '厂房项目-列表页'
            },
            component: () => import('@/pages/itemCommon/List'),
        },
        {
            path: 'atme',
            name: 'factory-item-sea-atme',
            meta: {
                title: '厂房项目-列表页'
            },
            component: () => import('@/pages/itemCommon/List'),
        },
        {
            path: 'meat',
            name: 'factory-item-sea-meat',
            meta: {
                title: '厂房项目-列表页'
            },
            component: () => import('@/pages/itemCommon/List'),
        },
        {
            path: 'reply',
            name: 'factory-item-sea-reply',
            meta: {
                title: '厂房项目-列表页'
            },
            component: () => import('@/pages/itemCommon/List'),
        },
        {
            path: 'search',
            name: 'factory-item-sea-search',
            meta: {
                title: '厂房项目-列表页'
            },
            component: () => import('@/pages/itemCommon/List'),
        },
    ]
}


// WEBPACK FOOTER //
// ./src/router/factory/seaitem/index.js